import { authReducer } from "./slices/auth";
import { dappModalReducer } from "./slices/dapp";
import { loaderReducer } from "./slices/loader";
import { marketReducer } from "./slices/market";
import { notificationsReducer } from "./slices/notifications";
import { statusReducer } from "./slices/status";
import { walletReducer } from "./slices/wallet";

export const sharedReducers = {
  loader: loaderReducer,
  dapp: dappModalReducer,
  status: statusReducer,
  wallet: walletReducer,
  auth: authReducer,
  notifications: notificationsReducer,
  market: marketReducer,
};

export type SharedState = {
  loader: ReturnType<typeof loaderReducer>;
  dapp: ReturnType<typeof dappModalReducer>;
  status: ReturnType<typeof statusReducer>;
  wallet: ReturnType<typeof walletReducer>;
  auth: ReturnType<typeof authReducer>;
  notifications: ReturnType<typeof notificationsReducer>;
  market: ReturnType<typeof marketReducer>;
};